import { Component, ViewEncapsulation } from '@angular/core';

import { EmailImageAssetDirective } from '../../directives/email-image-asset.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';

@Component({
  selector: 'email-tellent-logo',
  styleUrls: ['./email-tellent-logo.component.less'],
  template: `
    <a href="https://tellent.com/" target="_blank">
      <img
        class="logo"
        [src]="'assets/logo-tellent-new.png'"
        [width]="152"
        [height]="32"
        alt="Tellent"
      />
    </a>
  `,
  imports: [EmailImageAssetDirective],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class EmailTellentLogoComponent {}
